'use client'

import { useNavigationBrand } from 'hooks/useNavigationBrand/useNavigationBrand'
import { MenuRefType } from 'menu/context/MenuContext/MenuRefContext'
import { useMenus } from 'menu/hooks/useMenus'
import { setMinWidthForStructure } from 'menu/utils/minWidthForStructureLPlus'
import { useEffect, useRef } from 'react'
import type { Brand, BrandId } from 'types/brands'

import { BrandsUnderline } from '../BrandsUnderline/BrandsUnderline'
import { BrandEntry } from './BrandEntry/BrandEntry'

import styles from './Brands.module.css'

export interface BrandMenu {
	id: BrandId
	labelKey: string
	subBrands?: Brand[]
	url: string
}

type BrandsProps = {
	readonly brands: BrandMenu[]
	readonly isTopBar?: boolean
	readonly handleOpenMenu?: () => void
}

export function Brands({
	brands,
	isTopBar = false,
	handleOpenMenu,
}: BrandsProps) {
	const { brand: defaultBrand } = useNavigationBrand()
	const { open, updateRefs } = useMenus()
	const refBrands = useRef<HTMLUListElement | null>(null)

	useEffect(() => {
		if (refBrands.current) {
			setMinWidthForStructure(refBrands.current, open)
		}
	}, [refBrands.current, open])

	useEffect(() => {
		if (refBrands.current) {
			updateRefs(MenuRefType.BRANDS, refBrands)
		}
	}, [refBrands.current])

	if (brands.length === 0) {
		return null
	}

	return (
		<nav>
			<ul className={styles.brandsList} ref={refBrands}>
				{brands.map((brand, index) => (
					<BrandEntry
						key={brand.id}
						brand={brand}
						brandIndex={index}
						isTopBar={isTopBar}
						handleOpenMenu={handleOpenMenu}
						defaultBrand={isTopBar ? undefined : defaultBrand}
					/>
				))}
			</ul>
			{isTopBar && <BrandsUnderline />}
		</nav>
	)
}
